import { render, staticRenderFns } from "./ModelReview.vue?vue&type=template&id=dd4bc626&"
import script from "./ModelReview.vue?vue&type=script&lang=js&"
export * from "./ModelReview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports